import { getRandomPropping, pickMultiParentCrPropping } from '../common';
import productService from '../../products';
import { ITEMS } from '../../../constants';

function pickPropping(args) {
  const { isDynamic, proppingItem, item } = args;
  if (!isDynamic) {
    return getRandomPropping(proppingItem || item);
  } else if (productService.isType(item, ITEMS.CLOTHES_RAIL)) {
    return pickMultiParentCrPropping(args);
  }
}

export default { pickPropping };
